import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';

export default function useSelectedParty() {
  const {
    party: { party },
  } = useEmail();

  return party;
}
